import { SrInsightType } from '@plato/data/starrocks/types';

export type CategoryBreadcrumb = {
    title: string;
    id: string;
    depth: number;
};

type RawCategoryBreadcrumb = Omit<CategoryBreadcrumb, 'title'> & { title?: string };

export function safeParseBreadcrumbs(value: string | null | undefined): CategoryBreadcrumb[] | undefined {
    try {
        if (!value) {
            return undefined;
        }
        const parsed = JSON.parse(value) as RawCategoryBreadcrumb[];
        return parsed.map((b) => ({ ...b, title: b.title ?? '' }));
    } catch {
        return undefined;
    }
}

/**
 * Insight types whose € counts as opportunity. Deliberately a whitelist:
 * `ai_ins__insight` also carries churn-generation data under types the app
 * doesn't model (e.g. `ChurnWarningV2WebCategory`, `GlobalChurnWarning`),
 * which must never land in an opportunity sum. A new opportunity type must be
 * added here to count.
 */
export const opportunityInsightTypes = [
    SrInsightType.CROSS_SELL,
    SrInsightType.FIRST_PURCHASE,
    SrInsightType.SHARE_OF_WALLET,
    SrInsightType.PREVIOUSLY_PURCHASED,
    SrInsightType.INDUSTRY_TOP,
    SrInsightType.GLOBAL_TOP,
] as const;
